<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 滚动区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">状态：</span>
					<el-select v-model="search_status" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option :value="1" label="成功"></el-option>
						<el-option :value="2" label="失败"></el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">excelId：</span>
					<el-input v-model="search_id" class="b_inp" placeholder="excelId"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<el-button type="primary" @click="handleSearchClick">搜索</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="applyCategory"
						label="申请类别"
					>
					</el-table-column>
					<el-table-column
						prop="num"
						label="赠送/扣除次数"
					>
					</el-table-column>
					<el-table-column
						prop="productCategory"
						label="产品类别"
					>
					</el-table-column>
					<el-table-column
						prop="customerName"
						label="客户姓名"
					>
					</el-table-column>
					<el-table-column
						prop="customerMobile"
						label="客户手机号"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="status"
						label="状态"
					>
					</el-table-column>
					<el-table-column
						prop="reason"
						label="原因"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 滚动区域 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				search_status: '',
				search_id: '',
				search_startDate: '',
				search_endDate: '',
				
				tableData: [],
				currentPage: 1,
				total: 0
			}
		},
		methods: {
			/****************************** @Events *****************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击搜索
			handleSearchClick() {
				this.currentPage = 1;
				this.getList();
			},
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/****************************** @Function *****************************/
			// 请求数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					rechargeExcelId: that.search_id,
					successFlag: that.search_status,
					start: that.search_startDate,
					end: that.search_endDate
				};
				Api.findRecordByExcel(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						that.total = res.data.data.total;
						res.data.data.records.forEach(v => {
							list.push({
								applyCategory: '样品赠送',
								num: v.times,
								productCategory: v.productName,
								customerName: v.customerName,
								customerMobile: v.customerPhone,
								time: v.createTs.split(' ')[0],
								status: v.successFlag == 1 ? '成功' : (v.successFlag == 2 ? '失败' : ''),
								reason: v.errDesc || ''
							});
						});
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			}
		}
	}
</script>

<style>
</style>
